import { Link } from 'react-router-dom';

export default function FinalCTASection() {
  return (
    <section className="w-full flex flex-col lg:flex-row min-h-[420px] md:min-h-[500px]">
      <div className="w-full lg:w-1/2 relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=High-energy%20warehouse%20fulfillment%20center%20with%20rows%20of%20colorful%20shipping%20boxes%20on%20conveyor%20belts%2C%20workers%20scanning%20barcodes%20under%20bright%20industrial%20LED%20lighting%2C%20modern%20logistics%20facility%20with%20tall%20metal%20shelving%20and%20vibrant%20tape%20sealers%2C%20dynamic%20commercial%20photography%20with%20bold%20primary%20colors&width=900&height=600&seq=cta-left-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet lifestyle"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
        <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-12">
          <span className="text-xs font-label text-background-200 uppercase tracking-wider">Hipobuy Spreadsheet</span>
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
              Get The<br />
              Best<br />
              Deals
            </h2>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-background-50 flex flex-col items-center justify-center p-8 md:p-12 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-4">
          Start Shopping<br />
          With Hipobuy
        </h2>
        <p className="text-foreground-600 font-body text-sm md:text-base max-w-md leading-relaxed mb-8">
          Access the complete Hipobuy Spreadsheet product catalog with organized categories, verified links, and comprehensive research tools. Find exactly what you are looking for with our curated spreadsheet resources.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold font-label hover:bg-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
          <Link
            to="/hipobuy-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 px-6 py-3.5 border border-foreground-300 text-foreground-800 rounded-full text-sm font-semibold font-label hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}